import { render, staticRenderFns } from "./PayItem.vue?vue&type=template&id=b35c6f82&scoped=true"
import script from "./PayItem.vue?vue&type=script&lang=js"
export * from "./PayItem.vue?vue&type=script&lang=js"
import style0 from "./PayItem.vue?vue&type=style&index=0&id=b35c6f82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35c6f82",
  null
  
)

export default component.exports